export const PROMPT_HELPER_GROUPS = {
    action: [
      'sitting, chair,',
      'crossed arms,',
      'against wall, leaning back,',
      'hands on own hips,',
      'looking back,',
      'lying, on bed,',
      'kneeling,',
      'hand on another\'s thigh,',
      'seductive smile, ',
      'biting own lip,',
    ],
    view: [
      'cowboy shot,',
      'full body,',
      'upper body,',
      'portrait,',
      'close-up,',
      'wide shot,',
      'from behind,',
      'from side,',
      'looking at viewer,',
      'dutch angle,',
    ],
    background: [
      'bedroom,',
      'beach,',
      'park,',
      'street,',
      'office,',
      'library,',
      'cafe,',
      'restaurant,',
      'bar,',
      'club,',
    ],
    nsfw: [
      'explicit,',
      'topless female,',
      'bottomless,',
      'wet clothes,',
      'stealth flashing,'
    ],
    rating: [
      'general',
      'sensitive',
      'nsfw',
      'explicit',
    ],
  };

  export const cameraMappings = {
    0: { name: 'static', description: 'Still camera.' },
    1: { name: 'zoom_in', description: 'Slow zoom towards subject' },
    2: { name: 'zoom_out', description: 'Slow zoom away from subject' },
    3: { name: 'shake_up_down', description: 'Camera pans up and down.' },
    4: { name: 'shake_left_right', description: 'Camera pans left and right.' },
  };